import { getFormattedDate } from "modules/utilities/utility";
import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import SoftBadge from "modules/common/SoftBadge";
import NoData from "assets/svgs/no_data/NoData";
import { Placeholder } from "react-bootstrap";
import Loader from "modules/Loader";

function SlotTableData({ tableData, isLoading }) {
  const header = [
    "Phone",
    "Email",
    "Feedback",
    "Booking Time",
    "Slot Time",
    "Is Finished",
    "Assigned To",
  ];

  return (
    <div>
      <table className="d-flex flex-column mt-3  rounded table-hover">
        <thead className="d-flex text-gray border-black border rounded-top table-head">
          <th className="flex-1 fw-bold text-secondary  ps-1 pe-1 border-end py-2 mt-1">
            <div className="form-check" style={{ marginLeft: "0.4rem" }}>
              <label
                className="form-check-label fw-bold text-black"
                htmlFor="flexCheckIndeterminate"
              >
                Name
              </label>
            </div>
          </th>
          {header?.map((item) => (
            <th className="flex-1 fw-bold ps-2 border-end text-black mt-1 py-1">
              {item}
            </th>
          ))}
        </thead>
        <div
          style={{
            minHeight: "40vh",
            maxHeight: "60vh",
            overflowY: "scroll",
          }}
          className="scrollable-container"
        >
          {isLoading ? (
            <div className="position-absolute mt-5 start-50 top-50 translate-middle">
              <div>
                <Loader />
              </div>
            </div>
          ) : tableData?.data ? (
            tableData?.data?.map((item, index) => {
              return (
                <tr
                  id="table-row-value"
                  key={item?._id}
                  className={
                    item.checked
                      ? `flex-1 border border-top-0 table-row py-2  ${
                          index === tableData?.data?.length - 1 &&
                          `rounded-bottom`
                        } d-flex justify-content-between selected-table-row`
                      : `flex-1 border border-top-0  table-row ${
                          index === tableData?.data?.length - 1 &&
                          `rounded-bottom`
                        } d-flex justify-content-between`
                  }
                >
                  <td className="flex-1 ps-1 pe-1   border-end text-break text-primary cursor-pointer fw-bold">
                    <OverlayTrigger
                      overlay={
                        <Tooltip
                          style={{ position: "fixed" }}
                          id="overlay-trigger-example"
                        >
                          <div className="fs-1">Lead Details</div>
                        </Tooltip>
                      }
                    >
                      <Link
                        to={`/lead-details/${item?.caseId}`}
                        className="text-primary"
                      >
                        {item?.name}
                      </Link>
                    </OverlayTrigger>
                    <span className="">
                      <SoftBadge bg="primary" className="ms-2 ">
                        {item?.status}
                      </SoftBadge>
                      <SoftBadge bg="info" className="ms-2 ">
                        {item?.formStatus ? "F" : "-"}
                      </SoftBadge>
                    </span>
                  </td>
                  <td className="flex-1 ps-2 text-left   border-end text-break text-black">
                    {item?.phoneNo}
                  </td>
                  <td className="flex-1 ps-2  text-left  border-end text-break text-wrap text-black">
                    {item?.email}
                  </td>
                  <td className="flex-1  ps-2  text-left border-end text-break text-primary">
                    {item?.feedback}
                  </td>
                  <td className="flex-1 py-3    ps-2 text-left border-end text-break text-primary">
                    {getFormattedDate(item?.bookingTime)}
                  </td>
                  <td className="flex-1  py-3 ps-2 text-left border-end text-break text-black">
                    {getFormattedDate(item?.slotTime)}
                  </td>
                  <td className="flex-1  ps-2 py-3 text-left  border-end text-break text-black">
                    {item?.isFinished ? "Yes" : "No"}
                  </td>
                  <td className="flex-1  ps-1 text-left  border-end text-break text-black">
                    {item?.rep}
                    <SoftBadge bg="success" className="me-2 ">
                      {item?.repLevel}
                    </SoftBadge>
                  </td>
                </tr>
              );
            })
          ) : (
            <h3 className="text-center border p-3 rounded-bottom bg-white text-black">
              Data not found <NoData />
            </h3>
          )}
        </div>
      </table>
    </div>
  );
}

export default SlotTableData;
